// @flow

import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import LoginForm from 'app/login/components/LoginForm';

const Description = ({ previous }) => (
  <span>
    <p>
      To use Zapier, you need to enable cookies, including third-party cookies.
      Please refer to your browser’s help docs for instructions on how to enable
      them.
    </p>
    <p>
      If cookies are enabled, you should <a href={previous}>go back</a> and try
      again.
    </p>
  </span>
);

const mapStateToProps = state => {
  const previous = _.get(state.router, ['previous', 'url'], '/app/login');

  return {
    title: 'Cookies Disabled',
    description: <Description previous={previous} />,
  };
};

const mapDispatchToProps = () => {
  return {};
};

const CookiesDisabledFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default CookiesDisabledFormContainer;
